/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Alpha_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Alpha video export complete!" |
*
* @param {Video_Export_Alpha_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_complete_toast = /** @type {((inputs?: Video_Export_Alpha_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation video alpha terminee !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alpha-Videoexport abgeschlossen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione video Alpha completata!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт альфа-канала видео завершен!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Exportación de video alfa completada!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Alpha 视频导出完成！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アルファビデオのエクスポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अल्फा वीडियो का निर्यात सफलतापूर्वक पूरा हुआ!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação do vídeo alfa concluída!")
	return /** @type {LocalizedString} */ ("Alpha video export complete!")
});